import { render, staticRenderFns } from "./LineItemsSkeleton.vue?vue&type=template&id=15ac21e4&scoped=true"
import script from "./LineItemsSkeleton.vue?vue&type=script&lang=js"
export * from "./LineItemsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LineItemsSkeleton.vue?vue&type=style&index=0&id=15ac21e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac21e4",
  null
  
)

export default component.exports